<div class="inner-panel w-100 p-3 {{ customs }} {{ border }}">
  <ng-content></ng-content>
</div>
